import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertError, apiV2Request } from "../apiV2Request";

export const useBusinessTwoAccountVerificationEmail = (businessId: number) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `businesses/${businessId}/two-account-verification-email`,
      }).then((response) => apiV2AssertError(response)),
  });
};
